import React from 'react';
import { cn, getStatusColor } from '../../lib/utils';
import { CheckCircle, AlertTriangle, XCircle, Minus } from 'lucide-react';

export const StatusBadge = ({ status, label, size = 'default', showIcon = true }) => {
  const getIcon = () => {
    switch (status?.toLowerCase()) {
      case 'good':
      case 'on_track':
        return CheckCircle;
      case 'warning':
        return AlertTriangle;
      case 'critical':
      case 'error':
        return XCircle;
      default:
        return Minus;
    }
  };

  const Icon = getIcon();
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs';

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-semibold',
        sizeClasses,
        getStatusColor(status)
      )}
      data-testid={`status-badge-${status}`}
    >
      {showIcon && <Icon className={size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5'} />}
      <span>{label || status}</span>
    </span>
  );
};

export default StatusBadge;
